import * as React from "react"
import cx from "classnames"
import { useMouse } from "react-use"

import styles from "./flashlight.module.scss"

const Flashlight = ({ className, children }) => {
  const ref = React.useRef(null)
  // const { y } = useWindowScroll()
  const { elX, elY } = useMouse(ref)

  return (
    <div
      className={cx(styles.flashlight, className)}
      ref={ref}
      // eslint-disable-next-line no-useless-computed-key
      style={{ ["--x"]: elX, ["--y"]: elY }}
    >
      {children}
      <div className={styles.light} />
    </div>
  )
}

export default Flashlight
